import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";
import _ from "lodash";

import Wrapper from "../components/Wrapper";
import Header from "../components/Header";
import Body from "../components/Body";
import TopBar from "../components/TopBar";
import SubmitButton from "../components/SubmitButton";

import Typography from "@material-ui/core/Typography";
import Icon from "@material-ui/core/Icon";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import Checkbox from "@material-ui/core/Checkbox";
import numeral from "numeral";
import moment from "moment";

const fontDefault = {
  fontFamily: "thonburiregular",
  fontStyle: "normal",
  color: "rgb(14 22 44)"
};

const styles = {
  textTopBar: {
    ...fontDefault,
    color: "#333333",
    fontSize: "18px",
    fontWeight: "bold"
  },
  section: {
    padding: "24px 16px",
    backgroundColor: "white"
  },
  sectionMargin: {
    padding: "24px 16px",
    marginBottom: "8px",
    backgroundColor: "white"
  },
  flexSpace: {
    display: "flex",
    justifyContent: "space-between",
    alignItem: "flex-start"
  },
  flexSpaceCenter: {
    display: "flex",
    justifyContent: "space-between",
    alignItem: "center"
  },
  cardHead: {
    ...fontDefault,
    fontSize: "18px",
    fontWeight: "bold"
  },
  cardHeadSmall: {
    ...fontDefault,
    fontSize: "16px",
    fontWeight: "bold"
  },
  cardEdit: {
    ...fontDefault,
    fontSize: "14px",
    color: "rgb(17 141 245)"
  },
  cardName: {
    ...fontDefault,
    fontSize: "14px",
    color: "rgb(135 139 150)",
    whiteSpace: "nowrap",
    marginRight: "16px"
  },
  cardValue: {
    ...fontDefault,
    fontSize: "16px",
    textAlign: "right"
  },
  divider: {
    display: "block",
    height: "14px"
  },
  dividerSmall: {
    display: "block",
    height: "7px"
  },
  cardPrice: {
    ...fontDefault,
    fontSize: "32px",
    fontWeight: "bold"
  }
};

function trimIfPossible(text) {
  try {
    const newText = text.trim();
    if (newText === "-") {
      return "";
    } else {
      return newText;
    }
  } catch (error) {
    return text;
  }
}

class App extends Component {
  state = {
    agree: false
  };

  backToPreviousPage = () => {
    const {
      history: { push }
    } = this.props;
    push("/personal-info");
    document.getElementById("rootScreen").scrollTo(0, 0);
  };

  goToNextPage = () => {
    const {
      history: { push }
    } = this.props;
    push("/agreement");
    document.getElementById("rootScreen").scrollTo(0, 0);
  };

  render = () => {
    const { classes, auth } = this.props;
    const { userInput = {}, selectedPackage = {}, moreAddress = {} } = auth;
    const {
      firstName,
      lastName,
      ID,
      birthdate,
      phoneNumber,
      email,
      effDate,
      homeNo,
      moo,
      building,
      soi,
      road,
      address = "",
      gender = ""
    } = userInput;
    const { display_name_th, total_prem } = selectedPackage;
    const illness = _.get(selectedPackage, "coverage.illness", 0);
    const { agree } = this.state;
    let sumAddress = "";
    let eaddress = [];
    if (!!trimIfPossible(homeNo)) {
      eaddress.push(homeNo);
    }
    if (!!trimIfPossible(moo)) {
      eaddress.push("หมู่ที่ " + moo);
    }
    if (!!trimIfPossible(building)) {
      eaddress.push(building);
    }
    if (!!trimIfPossible(soi)) {
      eaddress.push("ซอย " + soi);
    }
    if (!!trimIfPossible(road)) {
      eaddress.push("ถนน " + road);
    }
    eaddress = eaddress.join(" ");

    sumAddress = eaddress + " " + _.get(moreAddress, "fullAddress", "");

    return (
      <Wrapper>
        <Body>
          <div className={classes.sectionMargin}>
            <div className={classes.flexSpaceCenter}>
              <Typography className={classes.cardHead}>
                ข้อมูลผู้เอาประกัน
              </Typography>
              <Typography
                onClick={this.backToPreviousPage}
                className={classes.cardEdit}
              >
                แก้ไข
              </Typography>
            </div>
            <div className={classes.dividerSmall} />
            <div className={classes.divider} />
            <div className={classes.flexSpaceCenter}>
              <Typography className={classes.cardName}>
                ชื่อผู้เอาประกันภัย
              </Typography>
              <Typography className={classes.cardValue}>
                {gender + " " + firstName + " " + lastName}
              </Typography>
            </div>
            <div className={classes.divider} />
            <div className={classes.flexSpaceCenter}>
              <Typography className={classes.cardName}>
                วัน/เดือน/ปีเกิด
              </Typography>
              <Typography className={classes.cardValue}>{birthdate}</Typography>
            </div>
            <div className={classes.divider} />
            <div className={classes.flexSpaceCenter}>
              <Typography className={classes.cardName}>
                เลขบัตรประชาชน
              </Typography>
              <Typography className={classes.cardValue}>{ID}</Typography>
            </div>
            <div className={classes.divider} />
            <div className={classes.flexSpaceCenter}>
              <Typography className={classes.cardName}>สัญชาติ</Typography>
              <Typography className={classes.cardValue}>ไทย</Typography>
            </div>
            <div className={classes.divider} />
            <div className={classes.flexSpaceCenter}>
              <Typography className={classes.cardName}>
                เบอร์โทรศัพท์
              </Typography>
              <Typography className={classes.cardValue}>
                {phoneNumber}
              </Typography>
            </div>
            <div className={classes.divider} />
            <div className={classes.flexSpace}>
              <Typography className={classes.cardName}>
                ที่อยู่ผู้เอาประกัน
              </Typography>
              <Typography className={classes.cardValue}>
                {sumAddress}
              </Typography>
            </div>
          </div>
          <div className={classes.sectionMargin}>
            <div className={classes.flexSpaceCenter}>
              <Typography className={classes.cardHeadSmall}>
                อีเมลสำหรับจัดส่งเอกสาร
              </Typography>
              <Typography
                onClick={this.backToPreviousPage}
                className={classes.cardEdit}
              >
                แก้ไข
              </Typography>
            </div>
            <div className={classes.flexSpaceCenter}>
              <Typography className={classes.cardValue}>{email}</Typography>
            </div>
          </div>
          <div className={classes.sectionMargin}>
            <Typography className={classes.cardHeadSmall}>
              รายละเอียดกรมธรรม์
            </Typography>
            <div className={classes.dividerSmall} />
            <div className={classes.divider} />
            <div className={classes.flexSpaceCenter}>
              <Typography className={classes.cardName}>แผนประกันภัย</Typography>
              <Typography className={classes.cardValue}>
                {display_name_th}
              </Typography>
            </div>
            <div className={classes.divider} />
            <div className={classes.flexSpaceCenter}>
              <Typography className={classes.cardName}>ทุนประกันภัย</Typography>
              <Typography className={classes.cardValue}>
                {numeral(illness).format("0,0")} บาท
              </Typography>
            </div>
            <div className={classes.divider} />
            <div className={classes.flexSpaceCenter}>
              <Typography className={classes.cardName}>
                วันเริ่มคุ้มครอง
              </Typography>
              <Typography className={classes.cardValue}>{effDate}</Typography>
            </div>
            <div className={classes.divider} />
            <div className={classes.flexSpaceCenter}>
              <Typography className={classes.cardName}>
                วันสิ้นสุดคุ้มครอง
              </Typography>
              <Typography className={classes.cardValue}>
                {moment(effDate)
                  .add(1, "years")
                  .subtract(1, "days")
                  .format("YYYY-MM-DD")}
              </Typography>
            </div>
            <div className={classes.divider} />
            <Typography className={classes.cardHeadSmall}>
              ราคาเบี้ยประกันรวม
            </Typography>
            <Typography className={classes.cardPrice}>
              {numeral(total_prem).format("0,0.00")} บาท
            </Typography>
            <br />
            <br />
            <SubmitButton onClick={this.goToNextPage} margin={false}>
              ต่อไป
            </SubmitButton>
          </div>
        </Body>
        <Header>
          <TopBar arrowLeft={this.backToPreviousPage} progress={3}>
            <Typography align="center" className={classes.textTopBar}>
              ตรวจสอบข้อมูล
            </Typography>
          </TopBar>
        </Header>
      </Wrapper>
    );
  };
}

const mapStateToProps = (state, ownProps) => {
  return {
    auth: state.auth || {}
  };
};

export default connect(mapStateToProps)(withStyles(styles)(App));
